export default __webpack_public_path__ + "static/media/evening-audio.bf749ff9.mp3";